export default __webpack_public_path__ + "static/media/vladi.3de9e5ac.jpg";